import { render, staticRenderFns } from "./QType8Answer.vue?vue&type=template&id=19beff06&scoped=true&"
import script from "./QType8Answer.vue?vue&type=script&lang=js&"
export * from "./QType8Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType8Answer.vue?vue&type=style&index=0&id=19beff06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19beff06",
  null
  
)

export default component.exports